
import { defineComponent, PropType } from 'vue'
import { Field, ErrorMessage } from 'vee-validate'
import { ModulesIdentifiers } from '@/store'
import { PartnerPropertyGetters } from '@/store/modules/partner-property/getters'
import { PartnerPropertyActions } from '@/store/modules/partner-property/actions'
import { SellDeviceType } from '@/types/partner-property'
import { isInvalid } from '@/utils'

export default defineComponent({
  name: 'SellDeviceTypeSelector',
  components: {
    Field,
    ErrorMessage,
  },
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch(
      `${ModulesIdentifiers.PARTNER_PROPERTY}/${PartnerPropertyActions.GET_SELL_DEVICES}`,
    )
    this.loading = false
  },
  props: {
    fieldName: {
      type: String,
      required: true,
    },
    fieldIdBase: {
      type: String,
      required: true,
    },
    values: {
      type: Object as PropType<{
        stores: { [key: string]: any }[]
        provides_sells: boolean
        sell_devices: string[]
      }>,
      default: () => {
        return { stores: null }
      },
    },
    errors: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  emits: ['changeSelection'],
  methods: {
    isInvalid,
    isOtherSelected(): boolean {
      if (this.loading) return false
      if (this.sellDeviceTypeOptions && this.sellDeviceTypeOther) {
        if (this.index < 0 && this.values.sell_devices) {
          return (
            this.values.sell_devices.findIndex(
              (obj) => obj == this.sellDeviceTypeOther.id,
            ) >= 0
          )
        }
        if (this.values.stores === null) return false
        if (!this.values.stores) return false
        if (
          this.values.stores.length <= 0 ||
          this.values.stores[this.index] === undefined
        )
          return false

        if (this.values.stores[this.index].sell_devices)
          return (
            this.values.stores[this.index].sell_devices.findIndex(
              (obj: string) => obj == this.sellDeviceTypeOther.id,
            ) >= 0
          )
      }
      return false
    },
    getDeviceName(id: string): string {
      const key = `${ModulesIdentifiers.PARTNER_PROPERTY}/${PartnerPropertyGetters.GET_SELL_DEVICE_NAME}`
      return this.$store.getters[key](id)
    },
    getSellDevices(): string[] {
      if (this.index < 0) return this.values.sell_devices
      if (this.values.stores === null) return []
      if (!this.values.stores) return []
      if (
        this.values.stores.length <= 0 ||
        this.values.stores[this.index] === undefined
      )
        return []
      return this.values.stores[this.index].sell_devices
    },
    existSellDevices(): boolean {
      if (this.index < 0)
        return this.values.sell_devices && this.values.sell_devices.length > 0
      if (this.values.stores === null) return false
      if (!this.values.stores) return false
      if (
        this.values.stores.length <= 0 ||
        this.values.stores[this.index] === undefined
      )
        return false
      return (
        this.values.stores[this.index].sell_devices &&
        this.values.stores[this.index].sell_devices.length > 0
      )
    },
  },
  computed: {
    sellDeviceTypeOptions(): SellDeviceType[] {
      const key = `${ModulesIdentifiers.PARTNER_PROPERTY}/${PartnerPropertyGetters.GET_SELL_DEVICES}`
      return this.$store.getters[key]
    },
    sellDeviceTypeOther(): SellDeviceType {
      const key = `${ModulesIdentifiers.PARTNER_PROPERTY}/${PartnerPropertyGetters.GET_OTHER_SELL_DEVICE}`
      return this.$store.getters[key]
    },
  },
})
